var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNFinitiBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "350 10 100 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d4af37;}.cls-3{fill:#505054;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 241.35,
    cy: 125,
    r: 68.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "242.27 104.11 242.27 85.57 206.22 85.57 206.22 164.43 226.84 164.43 226.84 137.98 242.27 137.98 242.27 119.49 226.84 119.49 226.84 104.11 242.27 104.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.98,145.96l-8.45-9.01c12.62-2.7,19.49-11.38,19.49-25.12,0-16.9-10.36-26.25-29.18-26.25h-7.57v10.43l21.93,15.81-21.93,15.81v10.38l14.22,26.45h24.56l-13.07-18.48Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.9,103.11c13.54,0,21.81,8.27,21.81,21.62v29.42h-14.85v-28.86c0-5.36-2.54-8.37-6.96-8.37s-6.96,3.01-6.96,8.37v28.86h-14.85v-29.42c0-13.35,8.27-21.62,21.81-21.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m397.03,154.15v-58.47h14.23v58.47h-14.23Zm4.12-46.44v-12.03h35.09v12.03h-35.09Zm4.07,26.08v-12.03h30.33v12.03h-30.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m460.45,154.15h-14.37v-58.47h14.37v58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m492.16,95.63l15.83,42.92h.64l-.64-24.71v-18.21h13.63v58.52h-19.17l-16.43-43.88h-.6l.64,25.26v18.62h-13.63v-58.52h19.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m547.93,154.15h-14.37v-58.47h14.37v58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m556.99,107.62v-11.94h46.58v11.94h-46.58Zm16.15,46.53v-55.73h14.32v55.73h-14.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m626.99,154.15h-14.37v-58.47h14.37v58.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNFinitiBlack);
export default __webpack_public_path__ + "static/media/Logo_nFiniti_black.72f49abf31434330cb7b61764f7c498a.svg";
export { ForwardRef as ReactComponent };